import { render, staticRenderFns } from "./HealthActionCard.vue?vue&type=template&id=0c135015"
import script from "./HealthActionCard.vue?vue&type=script&lang=js"
export * from "./HealthActionCard.vue?vue&type=script&lang=js"
import style0 from "./HealthActionCard.vue?vue&type=style&index=0&id=0c135015&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports